export default __webpack_public_path__ + "static/media/134-bangladesh.bb3051a6.svg";